import React, {Component} from 'react'
// import { connect } from 'react-redux'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

import {
    VISIBLE_ROOM_CLOSED,
    ROOM_STAYED,
    VISIBLE_ROOM_SWITCHED
} from '../../../constants/rooms';

class RoomPasswordPopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.afterClosePositionReset = false;

        this.onInputChange = this.onInputChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this._onVirtualLoginSuccess = this._onVirtualLoginSuccess.bind(this);
        this._onVirtualLoginFail = this._onVirtualLoginFail.bind(this);

        this.state = {
            ...super.state,
            error: '',
            password: ''
        };
    }

    onInputChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    onSubmit(event) {
        event.preventDefault();

        this.setState({error: ''});

        let {room} = this.props;

        Registry.get('chatInterface').joinRoom(
            room.roomid,
            this.state.password,
            this._onVirtualLoginSuccess,
            this._onVirtualLoginFail
        )
    }

    _onVirtualLoginSuccess() {
        this.props.dispatch({type: VISIBLE_ROOM_SWITCHED, room: this.props.room});
        this.setState({
            error: '',
            password: ''
        });
        this.close();
    }

    _onVirtualLoginFail() {
        this.setState({error: 'wrong-password'});
    }

    _afterClose() {
        if (this.state.error) {
            this.props.dispatch({type: VISIBLE_ROOM_CLOSED, roomid: this.props.room.roomid});
        }

        this.setState({
            error: '',
            password: ''
        });

        super._afterClose();
    }

    render() {
        let lang = Registry.get('locale');

        let {room} = this.props;

        let className = 'popup popup-password-room '+this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="top">
                    <p>{lang.closed_room}</p>
                    <div className="close" onClick={() => this.close()}></div>
                </div>

                <div className="content">
                    <p dangerouslySetInnerHTML={{__html:lang.please_provide_password_for_room(room.roomid)}}></p>
                    <form action="" onSubmit={this.onSubmit}>
                        <p className="error wrong-password" style={{display: this.state.error == 'wrong-password' ? 'block' : ''}}>{lang.wrong_password}</p>
                        <input type="text" name="password" placeholder={lang.password} autoComplete="off" onChange={this.onInputChange} value={this.state.password}/>
                        <input type="submit" value={lang.enter} className="popup-button"/>
                    </form>
                </div>
            </div>
        )
    }
}


RoomPasswordPopup.generateKey = function(props) { return 'room-password-popup' };
RoomPasswordPopup.mount = function(props, onMount) { return Popup.mount(RoomPasswordPopup, props, onMount) };
RoomPasswordPopup.open = function(props) {
    var id = RoomPasswordPopup.generateKey(props);
    RoomPasswordPopup.mount(props, () => Popup.popups[id].open());
};

export default RoomPasswordPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomPasswordPopup/index.js